var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconPlusCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M32.07 34.95H4.302a3.59 3.59 0 0 1-3.579-3.579V3.603A3.59 3.59 0 0 1 4.303.024H32.07a3.59 3.59 0 0 1 3.58 3.58V31.37a3.59 3.59 0 0 1-3.58 3.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 20,
    d: "M18.186 12.374v11.398"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 20,
    d: "M23.885 18.073H12.487"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666",
    strokeMiterlimit: 20,
    d: "M26.854 18.073a8.864 8.864 0 1 1-17.728 0 8.864 8.864 0 0 1 17.728 0z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPlusCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_plus_circle.a5b536b2.svg";
export { ForwardRef as ReactComponent };